import React from "react";
import EditIcon from "../assets/icons/edit-icon.svg";
import DeleteIcon from "../assets/icons/delete-icon.svg";
import "../styles/components/item.css";

const Item = ({ imageSrc, title, onEdit, onDelete }) => {
  return (
    <div className="item">
      <img src={imageSrc} alt={title} className="item-image" />
      <h3 className="item-title">{title}</h3>
      <div className="item-actions">
        {onEdit && (
          <button className="item-btn item-edit" onClick={onEdit}>
            <img src={EditIcon} alt="Edit" />
          </button>
        )}
        <button className="item-btn item-delete" onClick={onDelete}>
          <img src={DeleteIcon} alt="Delete" />
        </button>
      </div>
    </div>
  );
};

export default Item;
